<template>
  <div class="change-password">
    <div class="row mx-2 mt-4">
      <div class="col-md-6 mb-3">
        <Card title="Merchant" v-if="detail.customerInfoCommon">
          <Content title="Người đại diện" :content="detail.customerInfoCommon.customerName"></Content>
          <Content title="Email" :content="detail.customerInfoCommon.email"></Content>
          <Content title="Số điện thoại" :content="detail.customerInfoCommon.mobile"></Content>
          <Content title="Tên merchant" :content="detail.customerInfoCommon.merchantName"></Content>
          <Content title="Địa chỉ" :content="detail.customerInfoCommon.address"></Content>
        </Card>
        <Card title="Hợp đồng" class="mt-4">
          <Content title="Mã hợp đồng" :content="detail.code"></Content>
          <Content title="Trạng thái">
            <Status :value="detail.contractStateAgency" :config="Config.contractStatus"/>
          </Content>
          <Content title="Ngày tạo">
            {{ detail.dateCreated || detail.dateCreate | formatDateTime7 }}
          </Content>
          <Content v-if="detail.dateSign" title="Ngày ký">
            {{ detail.dateSign | formatDateTime7 }}
          </Content>
          <Content v-if="detail.dateCancel || detail.dateReject" title="Ngày huỷ">
            {{ detail.dateCancel || detail.dateReject | formatDateTime7 }}
          </Content>
        </Card>
      </div>
      <div class="col-md-6 mb-3">
        <Card title="Thiết bị">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Serial</th>
                <th scope="col">Loại thiết bị</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(device,index) in devices" :key="index">
                <td>
                  {{ device.displayName }}
                </td>
                <td>
                  {{device.serialNumber}}
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'
import { ContractService } from '@/services/contract.service'
export default {
  data () {
    return {
      showLoading: false,
      detail: {},
      detailContract: []
    }
  },
  components: { Card, Content },

  async created () {
    this.get()
  },
  computed: {
    devices () {
      return this.detail?.lstAppendixDevices?.[this.detail?.lstAppendixDevices.length - 1]?.appendixDevice?.deviceInfos ?? []
    }
  },
  methods: {
    async get () {
      this.showLoading = true
      try {
        const res = await ContractService.get(this.$route.params.id)
        if (res.success) {
          this.detail = res.data
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>
